import { TextButton } from '@oneaudi/unified-web-components';
import { useI18n } from '~/app/i18n/i18n';
import { StatusFragment } from '~/graphql/__generated__/graphql';

export function DialogItemActionButton({
	status,
	onAddToConfiguration,
}: {
	status: StatusFragment;
	onAddToConfiguration: () => void;
}) {
	const { i18n } = useI18n();

	if (!status.selected && status.available) {
		// Item can be added to configuration
		return (
			<TextButton variant="primary" onClick={onAddToConfiguration} size="md">
				{i18n('ngc.actions.addToConfiguration')}
			</TextButton>
		);
	}

	if (status.selected) {
		// Item is already selected
		return (
			<TextButton variant="secondary" disabled size="md" onClick={() => {}}>
				{i18n('ngc.actions.includedInConfiguration')}
			</TextButton>
		);
	}

	// Item is not available
	return (
		<TextButton variant="secondary" disabled size="md" onClick={() => {}}>
			{i18n('ngc.common.NotAvailable')}
		</TextButton>
	);
}
